import { DateFilter } from './types/DateFilter'
import { RadioList } from './types/RadioList'
import { CheckList } from './types/CheckList'
import { SearchTextBox } from './types/SearchTextBox'

const FilterTabContent = ({ type, ...rest }) => {
    switch (type) {
        case 'date':
            return <DateFilter {...rest} />
        case 'radio_list':
            return <RadioList {...rest} />
        case 'check_list':
            return <CheckList {...rest} />
        case 'search_textbox':
            return <SearchTextBox {...rest} />
        default:
            return null
    }
}

export { FilterTabContent }
